import { createFileRoute } from '@tanstack/react-router';
import ResetPassword from '../components/ResetPassword';
import { LanguagesContext, LanguageContextProps } from '../components/LanguagesContext';

export const Route = createFileRoute('/reset-password/$token')({
  beforeLoad: () => ({ documentTitle: { main: 'resetPassword.pageTitle' } }),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useParams();

  return (
    <LanguagesContext.Consumer>
      {(context: LanguageContextProps) => <ResetPassword context={context} token={token} />}
    </LanguagesContext.Consumer>
  );
}
